import CardAddContentButton from '@/components/ui/custom/CardAddContentButton';
import Lesson from '@/models/Lesson';
import { useTranslation } from 'react-i18next';

type LessonAddQuestionsButtonProps = Pick<Lesson, 'activities'> & {
  onAddQuestions?: () => void;
};

const LessonAddQuestionsButton = ({
  activities,
  onAddQuestions,
}: LessonAddQuestionsButtonProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.courseWorkspace.unitsTab',
  });

  return (
    <CardAddContentButton
      label={t('addQuestions')}
      count={activities.length}
      onClick={onAddQuestions}
    />
  );
};

export default LessonAddQuestionsButton;
